/* ModaConcrete — Shipping popup on product pages.
   Converts the "Shipping calculated at checkout" link into an in-page modal
   instead of a navigation / new tab. Reads the policy HTML exposed by
   snippets/mc-shipping-modal.liquid (window.mcShippingPolicyHTML). */
(function () {
  'use strict';
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function () {
    var policy = window.mcShippingPolicyHTML;
    if (!policy) return;
    var policyUrl = window.mcShippingPolicyURL || '/policies/shipping-policy';
    var modal = null, lastFocus = null;

    function build() {
      if (modal) return;
      var style = document.createElement('style');
      style.textContent =
        '.mc-modal[hidden]{display:none!important}' +
        '.mc-modal{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:20px}' +
        '.mc-modal__overlay{position:absolute;inset:0;background:rgba(30,28,26,.55)}' +
        '.mc-modal__dialog{position:relative;background:#f8f4ec;color:#2b2b2b;max-width:560px;width:100%;max-height:82vh;overflow:auto;border-radius:4px;padding:34px 38px 30px;box-shadow:0 24px 60px rgba(0,0,0,.28)}' +
        ".mc-modal__title{font-family:'Cormorant Garamond',serif;font-size:33px;font-weight:400;margin:0 0 .45em;letter-spacing:.01em}" +
        '.mc-modal__body{font-size:15px;line-height:1.6}' +
        '.mc-modal__body p{margin:0 0 1em}.mc-modal__body>*:last-child{margin-bottom:0}' +
        '.mc-modal__full{display:inline-block;margin-top:18px;font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#746355;border-bottom:1px solid currentColor;padding-bottom:2px;text-decoration:none}' +
        '.mc-modal__close{position:absolute;top:12px;right:16px;background:none;border:0;font-size:28px;line-height:1;cursor:pointer;color:#746355}' +
        '.mc-modal__close:hover{color:#2b2b2b}' +
        'body.mc-modal-open{overflow:hidden}';
      document.head.appendChild(style);
      modal = document.createElement('div');
      modal.className = 'mc-modal';
      modal.hidden = true;
      modal.setAttribute('role','dialog');
      modal.setAttribute('aria-modal','true');
      modal.setAttribute('aria-label','Shipping');
      modal.innerHTML =
        '<div class="mc-modal__overlay" data-close></div>' +
        '<div class="mc-modal__dialog" role="document">' +
        '<button type="button" class="mc-modal__close" data-close aria-label="Close">&times;</button>' +
        '<h2 class="mc-modal__title">Shipping</h2>' +
        '<div class="mc-modal__body rte">' + policy + '</div>' +
        '<a class="mc-modal__full" href="' + policyUrl + '">View full shipping policy</a>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target.hasAttribute('data-close')) close(); });
    }
    function open(e){ if(e){e.preventDefault();} lastFocus=document.activeElement; build(); modal.hidden=false; document.body.classList.add('mc-modal-open'); var c=modal.querySelector('.mc-modal__close'); if(c){c.focus();} }
    function close(){ if(!modal)return; modal.hidden=true; document.body.classList.remove('mc-modal-open'); if(lastFocus&&lastFocus.focus){lastFocus.focus();} }

    document.addEventListener('click', function (e) {
      if(!e.target.closest) return;
      var t = e.target.closest('.product__tax a[href*="/policies/shipping-policy"], a.mc-shipping-open');
      if (t) open(e);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
  });
})();
